import EvidendeIndicator from "../../evidence/EvidenceIndicator";
import GhostInfoSection from "../GhostInfoSection";
import SanityIndicator from "../SanityIndicator";
import SpeedIndicator, { speedExactly, speedOr } from "../SpeedIndicator";
import SpeedSymbol from "../SpeedSymbol";

export default function Obambo() {
    return (
        <div>
            <div className="ghost-details">
                <GhostInfoSection title="Evidence">
                    <ul className="list-unstyled">
                        <li><EvidendeIndicator evidenceType="Ghost Writing" /></li>
                        <li><EvidendeIndicator evidenceType="Ultraviolet" /></li>
                        <li><EvidendeIndicator evidenceType="D.O.T.S." /></li>
                    </ul>
                </GhostInfoSection>
                <GhostInfoSection title="Behaviour">
                    Has two different states:
                    <ul>
                        <li>
                            <strong>calm</strong>,
                            where it has <strong>high activity</strong>, 
                            hunts at <ObamboSanityIndicator which="calm" /> and 
                            is slower at <ObamboSpeedIndicator which="calm" />.
                        </li>
                        <li>
                            <strong>aggressive</strong>,
                            where it has <strong>low activity</strong>, 
                            hunts at <ObamboSanityIndicator which="aggressive" /> and 
                            is faster at <ObamboSpeedIndicator which="aggressive" />.
                        </li>
                    </ul>

                    It always starts <em>calm</em>, then switches one minute later, and then 
                    again every two minutes, even during a hunt.
                </GhostInfoSection>
                <GhostInfoSection title="Hunt">
                    The hunt will be 20% shorter if the Obambo starts the hunt in the 
                    aggressive state.
                </GhostInfoSection>
            </div>
        </div>
    );
}

export function ObamboSanityIndicator({ which }: { which?: 'calm' | 'aggressive' }) {
    return (
        <>
        {which !== 'aggressive' && <SanityIndicator sanity={10} tooltip="calm state" />}
        {which !== 'calm' && <SanityIndicator sanity={65} tooltip="aggressive state" />}
        </>
    );
}

export function ObamboSpeedIndicator({ which }: { which?: 'calm' | 'aggressive' }) {
    const slow = speedExactly(1.45);
    const fast = speedExactly(1.96);

    return (
        <>
        {which !== 'aggressive' && <SpeedSymbol speed={1.45} description="calm" speedingUp />}
        {which !== 'calm' && <SpeedSymbol speed={1.96} description="aggressive" speedingUp />}
        <SpeedIndicator speed={speedOr(slow, fast)} />
        </>
    );
}